<script setup lang="ts">
import {ConsumerProduct} from "@/consumer/interfaces";
import TrackerLayout from "@/interview/components/instance-modal/consumer-product-tracking/trackers/TrackerLayout.vue";
import {computed, inject} from "vue";
import dateHelper from "@/core/helpers/dateHelper";
import {Button} from "@/core/components/ui/button";

const props = defineProps<{
    consumerKey: string;
    girerdId: number;
    latestInstance: Date | null;
    products: ConsumerProduct[];
}>();

const emits = defineEmits<{ (e: 'surveyClosed'): void; }>();
const openSurveyModal = inject<(surveyId: number, consumerKey: string, pathwayStepId?: number, supportProgramId?: number, type?: string, options?: Record<string, unknown>) => Promise<void>>('openSurveyModal');

/**
 * The observance is done if the latest girerd instance is after the latest created product
 */
const done = computed(() => {
    if (!props.products.length || !props.latestInstance) {
        return false;
    }

    const latestCreatedProduct = props.products.reduce((latest, product) => {
        const createdAt = new Date(product.created_at);
        return createdAt > latest ? createdAt : latest;
    }, new Date(props.products[0].created_at));

    return props.latestInstance >= latestCreatedProduct;
});

/**
 * Start the girerd survey.
 */
const startSurvey = () => {
    if (!openSurveyModal) {
        return;
    }

    openSurveyModal(
        props.girerdId,
        props.consumerKey,
        undefined,
        undefined,
        'survey',
        {
            showVerdict: true,
            onClose: () => {
                emits('surveyClosed');
            },
        }
    );
};
</script>

<template>
  <TrackerLayout title="Observance" :state="done ? 'done' : 'to-do'">
    <template v-if="latestInstance" #latest>
      Dernier contrôle le {{ dateHelper.shortFormat(latestInstance) }}
    </template>
    <template #action>
      <Button variant="ghost" size="xs" class="text-primary" @click="startSurvey">
        Lancer un GIRERD
      </Button>
    </template>
  </TrackerLayout>
</template>

<style scoped>

</style>
